/* Flowbam shared product cards: tap the image to preview the second image on touch devices. */
(function () {
  document.addEventListener('click', function (event) {
    var image = event.target.closest('[data-card-image-toggle]');
    if (!image || !window.matchMedia('(hover: none)').matches) return;

    event.preventDefault();
    event.stopPropagation();
    image.classList.toggle('is-secondary');
  });
})();
